<div class=cpcontent>
    <h2> BaseComponent Tester</h2>
    Basecomponent is a typescript file that should be injected into every component.
    It provides convenient access to the most common used services and functionalities. It is in the shared folder.
    <ul>
        <li>Alert Services</li>
        <li>Toast Services</li>
        <li>Loader Services</li>
        <li>Router</li>
        <li>Route</li>
        <li>Location</li>
    </ul>
    To see how to extend any components with the base component see the typescript of this component.
    <br><br>
    In addition the basecomponent provides additional utility functions:

    <h5>Lookup</h5>
    Whenever you have an id and want to look it up in a table:
    <br>
    Id: {{id}}<br>
    Name: {{lookup(id,names)}}
    <br>
    Names:
    <pre [innerHTML]="names | json"></pre>
</div>